import {Route, Routes} from "react-router-dom";
import {NotFount} from "../../layouts/not-fount";
import {Layout} from "../template/Layout";
import Process from "../../layouts/process";
import AdminUser from "../../layouts/admin-user";
import Departments from "../../layouts/departments";
import {useSessionStore} from "../../services/storage/session/SessionStorage";
import {RolEnum} from "../../services/enum/PermissionConst";

export default function Body() {
    const user = useSessionStore(data => data.user)

    return (
        <Layout>
            <Routes>
                <Route path=""
                       element={<Process/>}
                />
                <Route path="/processes"
                       element={<Process/>}
                />
                {user?.rol === RolEnum.ADMIN &&
                    <>
                        <Route path="/admin-user"
                               element={<AdminUser/>}
                        />
                        <Route path="/departments"
                               element={<Departments/>}
                        />
                    </>
                }
                <Route path="/*"
                       element={<NotFount code={'404'}/>}
                />
            </Routes>
        </Layout>
    );
}
